import { render, staticRenderFns } from "./responsabilidades-sgsst-editar.vue?vue&type=template&id=3b28164e&scoped=true&"
import script from "./responsabilidades-sgsst-editar.vue?vue&type=script&lang=js&"
export * from "./responsabilidades-sgsst-editar.vue?vue&type=script&lang=js&"
import style0 from "./responsabilidades-sgsst-editar.vue?vue&type=style&index=0&id=3b28164e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b28164e",
  null
  
)

export default component.exports